import React, { Component } from "react";
import { withRouter } from "react-router";
import FarmShopConnectLogo from "../../images/FarmShopConnectLogo.png";
import Otp from "../../screens/Login/Otp";
import LoginService from "../../api/LoginService";
import AuthService from "../../session/AuthService";
import { Col, Form, Row } from "react-bootstrap";
import { Toaster , toast } from "react-hot-toast"



class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openOtppage: false,
      formValues: {},
      stateForResend : ""
    };
  }
  componentDidMount() {}

  render() {
    return (
      <>
        {!this.state.openOtppage ? (
          <div className="login-page">
            <div className="logo-container">
              <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
            </div>
            <div className="login-card">
              {AuthService.getStateofLoginPage() === "forgotPassword" && (
                <>
                  <h5 style={{ fontWeight: "700" }}>Forgot password</h5>
                  <p style={{ color: "#545454", fontSize: "15px" }}>
                    We will send an OTP to your mail to verify your account
                  </p>
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={this.handleForm}
                    name="mailId"
                    value={this.state.formValues.mailId}
                    onKeyDown={this.handleKeyDown}
                  />
                </>
              )}
              {AuthService.getStateofLoginPage() === "firstTimeUser" && (
                <>
                  <Row>
                    <h5 style={{ fontWeight: "700" }}>Sign Up</h5>
                    <p style={{ color: "#545454", fontSize: "15px" }}>
                      We will send an OTP to your mail to verify your account
                    </p>
                    <Col>
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="First Name"
                          autoFocus
                          className="small-input"
                          name="firstName"
                          value={this.state.formValues.firstName}
                          onChange={this.handleForm}
                          onKeyDown={this.handleKeyDown2}
                        />
                      </Form.Group>
                    </Col>
                     
                    <Col>
                      <Form.Group
                        className="mb-2"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Last Name"
                          autoFocus
                          className="small-input"
                          name="lastName"
                          value={this.state.formValues.lastName}
                          onChange={this.handleForm}
                          onKeyDown={this.handleKeyDown2}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        autoFocus
                        className="small-input"
                        name="mailId"
                        value={this.state.formValues.mailId}
                        onChange={this.handleForm}
                        onKeyDown={this.handleKeyDown2}
                      />
                    </Form.Group>
                  </Row>
                 
                </>
              )}
              {AuthService.getStateofLoginPage() === "forgotPassword" && (
                <div className="allign-button d-flex justify-content-center" >
                  {/* <span className="back-to-login" onClick={this.backToLogin}>Back To Login</span> */}
                  <button
                    type="button"
                    className="btn btn-success"
                    id="successbutton"
                    onClick={this.openOtp}
                     
                  >
                    Send OTP
                  </button>
                </div>
              )}
              {AuthService.getStateofLoginPage() === "firstTimeUser" && (
                       <div className="allign-button d-flex justify-content-center">
                       {/* <span className="back-to-login" onClick={this.backToLogin}>Back To Login</span> */}
                       <button
                         type="button"
                         className="btn btn-success"
                         id="successbutton"
                         onClick={this.firstTimeUser}
                       >
                         Send OTP
                       </button>
                     </div>
                    )}
            </div>
          </div>
        ) : (
          <Otp mailId={this.state.formValues}  stateForResend={this.state.stateForResend} />
        )}
        <Toaster />
      </>
    );
  }

 

  openOtp = () => {
    LoginService.forgotPasswordMobile(this.state.formValues).then(
      (response) => {
        console.log("response", response.data.data);

        if (response.data.data === "otp send succesfully") {
          this.setState({
            openOtppage: true,
            stateForResend : "forgotpassword",
          });
        } else if (response.data.data === "User not Found") {
          toast.error("Email is Not Persent")
        } else {
        }
      }
    );
  };


  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
     
      event.preventDefault();
      

      this.openOtp();
    }
  };

  handleKeyDown2 = (event) => {
    if (event.key === 'Enter') {
     
      event.preventDefault();
      

      this.firstTimeUser();
    }
  };



  firstTimeUser = () => {

    if (!this.state.formValues.firstName){
      toast.error("Please Enter First Name")
    }else if (!this.state.formValues.lastName){
      toast.error("Please Enter Last Name")
    }else if (!this.state.formValues.mailId) {
      toast.error("Please Enter Email");
    } else if (!/\S+@\S+\.\S+/.test(this.state.formValues.mailId)) {
      toast.error("Please Enter a Valid Email");
    }else {
      LoginService.firstTimeUser(this.state.formValues).then((response) => {
        console.log("response", response.data.data);
  
          if (response.data.data === "otp send succesfully") {
            this.setState({
              openOtppage: true,
              stateForResend : "firsttimeuser",
            });
          } else if (response.data.data === "User present with this Email") {
            toast.error("Email Already Exists")
          } else {
          }
      })
    }
   
  
  

  }

  handleForm = (event) => {
    let form = { ...this.state.formValues };

    form[event.target.name] = event.target.value;

    this.setState(
      {
        formValues: form,
      });
  };
}

export default withRouter(ForgotPasswordForm);
